import { z } from 'zod'

import type { ZodInfer } from '@mntn-dev/utility-types'

export const UbsAgreementIdSchema = z.int().positive().brand('ubs-agreement')
export type UbsAgreementId = ZodInfer<typeof UbsAgreementIdSchema>

export const UbsAgreementId = (value: number): UbsAgreementId =>
  UbsAgreementIdSchema.parse(value)
